const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1.304 -1.43051e-06C1.496 -1.43051e-06 1.656 0.0479989 1.784 0.144C1.928 0.224 2.032 0.303999 2.096 0.383999C2.16 0.463999 2.24 0.591999 2.336 0.767999V8.52L2.36 16.248L2.408 16.56C2.648 17.984 3.28 19.184 4.304 20.16C5.328 21.136 6.592 21.728 8.096 21.936C8.352 21.968 8.648 21.984 8.984 21.984C10.888 21.984 12.52 21.304 13.88 19.944C14.776 19.016 15.336 17.888 15.56 16.56L15.608 16.248C15.608 14.52 15.616 11.936 15.632 8.496C15.648 5.056 15.656 2.48 15.656 0.767999C15.864 0.255999 16.184 -1.43051e-06 16.616 -1.43051e-06C17.128 -1.43051e-06 17.456 0.239999 17.6 0.719999C17.632 0.815999 17.648 3.392 17.648 8.448C17.648 13.568 17.64 16.184 17.624 16.296C17.464 18.248 16.696 19.936 15.32 21.36C14.12 22.56 12.728 23.352 11.144 23.736C10.504 23.896 9.784 23.976 8.984 23.976C8.184 23.976 7.472 23.896 6.848 23.736C5.104 23.32 3.624 22.432 2.408 21.072C1.192 19.728 0.504 18.136 0.344 16.296C0.328 16.184 0.32 13.568 0.32 8.448C0.32 3.392 0.336 0.815999 0.368 0.719999C0.48 0.239999 0.792 -1.43051e-06 1.304 -1.43051e-06Z",
  fill: "#1E3F6B"
});

const SvgEquationIntegrals10 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals10, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-10.c0b9d67d.svg";
export { ForwardRef as ReactComponent };